module.exports = __webpack_public_path__ + "img/612.090d5a6d.png";